let clerkTokenGetter = null

export const setClerkTokenGetter = fn => {
  clerkTokenGetter = fn
}

export const getClerkToken = async () => {
  if (!clerkTokenGetter) return ''
  try {
    const t = await clerkTokenGetter()
    return t || ''
  } catch {
    return ''
  }
}
